import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { Owned } from 'shell-models-lib';
import { BaseAdapter } from 'app/model/adapters/base.adapter';
import { StoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/store-read-settings';
import { FormatTypeCopySource } from 'app/model/pipeline/copysource/format-type.copysource';

export class GenericStoreReadSettingsAdapter extends BaseAdapter<StoreReadSettings, Model.StoreReadSettings> {
    protected _toResource(settings: StoreReadSettings): Model.StoreReadSettings {
        const settingsType = Metamodel.modelOf(settings).name;
        const result: Model.StoreReadSettings = {
            type: settingsType
        };
        return result;
    }

    protected _toModel(settings: Model.StoreReadSettings, copySource: FormatTypeCopySource): StoreReadSettings {
        const model = Metamodel.modelByName(settings.type);
        const result = Owned.create<StoreReadSettings>(model, copySource);
        return result;
    }
}
